import styles from "./Spinner.module.css";

interface SpinnerProps {
  label?: string;
}

const Spinner = ({ label = "Loading..." }: SpinnerProps) => (
  <div className={styles.spinnerWrap} role="status" aria-live="polite">
    <div className={styles.spinner} aria-hidden="true" />
    <span className={styles.srOnly}>{label}</span>
  </div>
);

export default Spinner;
